import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, MenuItem, TextField, Paper } from "@mui/material";
import Cookies from "universal-cookie";
import { Stack } from "@mui/system";
import moment from "moment";

//apis
import getMerciIngressoData from "../services/getMerciIngressoData";
import getMerciUscitaData from "../services/getMerciUscitaData";
import { Today } from "@material-ui/icons";

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    borderRadius: 2,
    flex: 1,
    bgcolor: 'white',
    boxShadow: 24,
    p: 4,
};

let cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
let userType = cookies.get('userType', { path: '/' });

export default class MyModalGiacenze extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            tipo: 'entrata',
            data_inzio: moment().format('YYYY-MM-DD'),
            data_fine: moment().add(7, 'days').format('YYYY-MM-DD'),
            merci: []
        }
    }

    async componentDidMount() {
        let merci_ingresso = await getMerciIngressoData(username, token, this.props.modal.id);
        let merci_uscita = await getMerciUscitaData(username, token, this.props.modal.id);
        let merci = this.joinData(merci_ingresso, 'ingresso', []);
        merci = this.joinData(merci_uscita, 'uscita', merci);
        this.setState({ merci });
    }

    joinData(array_check, key, array_results) {
        array_check.forEach(
            e => {
                if (e.data === '') return;
                let found = array_results.find((m) => m.data === e.data)
                if (found) {
                    found[key] = e[key]
                }
                else {
                    array_results.push(e)
                }
            }
        )
        return array_results
    }

    close() {
        this.props.onClose();
    }

    render() {
        return (
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={'column'} spacing={2} sx={{ flex: 1 }}>
                        {/* TITOLO */}
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {this.props.title}
                        </Typography>

                        {/* SELEZIONE INTERVALLO */}
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                            <TextField
                                type="date"
                                variant="outlined"
                                label="Dal"
                                value={this.state.data_inzio}
                                style={{ width: 400 }}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                    this.setState({ data_inzio: e.target.value })
                                }}
                            />
                            <TextField
                                type="date"
                                variant="outlined"
                                label="Al"
                                style={{ width: 400 }}
                                value={this.state.data_fine}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                    this.setState({ data_fine: e.target.value })
                                }}
                            />
                        </Stack>
                        {/* TABELLA */}
                        <TableContainer component={Paper}>
                            <Table size="small" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Ingresso</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Uscita</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.state.merci
                                            .filter((m) => {
                                                return moment(m.data).isBetween(moment(this.state.data_inzio), moment(this.state.data_fine))
                                            })
                                            .map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{moment(row.data).format('dddd, DD/MM/YYYY')}</TableCell>
                                                    <TableCell>{row.ingresso || 0}</TableCell>
                                                    <TableCell>{row.uscita || 0}</TableCell>
                                                </TableRow>
                                            ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                </Box>
            </Modal>
        )
    }
}